import UserDropDown from "@/components/ui/UserDropDown";

const NotificationHeader = () => {
  return (
    <div className="flex justify-between  px-4 md:px-11 py-4 border-b-[1.5px]">
      <div className="space-y-2">
        <h3 className="text-[#17191E] text-lg font-semibold leading-[22px]">
          Notification
        </h3>
        <p className="text-[#667085] text-sm leading-4">
          Discover the unique projects and collaborations of our talented
          creators.
        </p>
      </div>
      <UserDropDown />
    </div>
  );
};

export default NotificationHeader;
